import { Link } from 'react-router-dom';
import { EconomicLoopDiagram } from '../components/EconomicLoopDiagram';

export default function HowItWorksPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-essence-gold">
        How it works
      </p>
      <h1 className="mt-3 max-w-3xl font-display text-4xl font-bold tracking-tight text-essence-ink sm:text-5xl">
        AI companies buy inference. That becomes Essence.
      </h1>
      <p className="mt-5 max-w-2xl text-lg leading-relaxed text-essence-mute">
        AI products need inference. Resonatia is built for that — distributed and edge capacity, often at a lower
        cost than default hyperscale routes. When companies pay for Resonatia API keys or hosting (Stripe today),
        that spend is reserved for a USDC treasury on Base. Self OS nodes earn Essence from verified work; agents
        settle against the same loop; humans convert to Talk credits today. Resonatia places compute. Essence
        manages value.
      </p>

      <div className="mt-10 max-w-2xl space-y-4 border-t border-essence-line pt-8">
        <h2 className="font-display text-xl font-semibold text-essence-ink">For inference buyers</h2>
        <p className="text-base leading-relaxed text-essence-mute">
          You are not “buying Essence” as a marketing gimmick. You are buying model access and hosting on
          Resonatia. Essence is the settlement and reward token on the other side of that demand — so the people
          and devices providing compute can be paid from the same economy.
        </p>
      </div>

      <div className="mt-14">
        <EconomicLoopDiagram />
      </div>

      <div className="mt-16 grid gap-10 lg:grid-cols-2">
        <div className="border-t border-essence-line pt-6">
          <h2 className="font-display text-2xl font-semibold text-essence-ink">Peg discipline</h2>
          <p className="mt-3 text-base leading-relaxed text-essence-mute">
            1 Essence ≈ $1 notional when the model is working as intended. EssenceTreasury is an ops-funded vault
            that backs redeemability toward USDC — not a regulated stablecoin, not FDIC-insured, and not a promise
            the vault is fully funded or that a 1:1 exit is always available today.
          </p>
        </div>
        <div className="border-t border-essence-line pt-6">
          <h2 className="font-display text-2xl font-semibold text-essence-ink">Who can mint</h2>
          <p className="mt-3 text-base leading-relaxed text-essence-mute">
            Only EssenceBridge mints ESSENCE. Owner / voucher signer today is the deployer ops wallet —
            admin/bridge-controlled mint, not a fair launch. Phones never mint on-chain; the cloud ledger credits
            first, and withdraw requires a Concierge-signed voucher plus funded treasury.
          </p>
        </div>
      </div>

      <div className="mt-14 flex flex-wrap gap-3">
        <Link
          to="/contracts"
          className="inline-flex rounded-lg bg-essence-teal px-5 py-3 text-sm font-semibold text-white hover:bg-essence-teal-bright"
        >
          View contracts
        </Link>
        <Link
          to="/for-nodes"
          className="inline-flex rounded-lg border border-essence-line px-5 py-3 text-sm font-semibold text-essence-ink hover:border-essence-gold/40"
        >
          For nodes
        </Link>
      </div>
    </div>
  );
}
